import React, { Fragment, Suspense } from 'react';
import { lazy } from '@loadable/component';
import CircularProgress from '@material-ui/core/CircularProgress';

const PaddedDivider = lazy(() => import('components/PaddedDivider'));
const BlockContentTypography = lazy(() =>
  import('components/BlockContent/elements/BlockContentTypography')
);
const InlineResourceCTA = lazy(() => import('components/InlineCTAs'), {
  resolveComponent: components => components.InlineResourceCTA
});

const LegacyPostContent = ({
  summary,
  content,
  resource_cta,
  resource_cta_inline
}) => (
  <Suspense fallback={<CircularProgress />}>
    <span data-swiftype-name="body" data-swiftype-type="text">
      <BlockContentTypography
        variant="body2"
        dangerouslySetInnerHTML={{ __html: summary }}
      />
      {content.split('<!--[InlineResource]-->').map((content, idx) => (
        <Fragment key={idx}>
          <BlockContentTypography
            variant="body2"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {resource_cta_inline && idx === 0 && (
            <InlineResourceCTA
              title={resource_cta_inline.title}
              resource={resource_cta_inline.resource[0]}
              size="wide"
            />
          )}
        </Fragment>
      ))}
    </span>
    {resource_cta && (
      <>
        <InlineResourceCTA
          title={resource_cta.title}
          resource={resource_cta.resource[0]}
          size="wide"
        />
        <PaddedDivider hide />
      </>
    )}
  </Suspense>
);

export default LegacyPostContent;
